import upperFirst from 'lodash/upperFirst';

export default defineNuxtPlugin((nuxtApp) => {
  const { $i18n } = useNuxtApp();
  const { t, te } = $i18n;
  const router = nuxtApp.vueApp.config.globalProperties.$router;
  const runtimeConfig = useConfig();

  if (router) {
    router.afterEach((to) => {
      const lemonwayEnv =
        runtimeConfig.value.public.lemonwayEnv.toLowerCase() === 'production'
          ? ''
          : ` (${upperFirst(runtimeConfig.value.public.lemonwayEnv)})`;

      document.title = `${runtimeConfig.value.public.appName}${lemonwayEnv}`;

      if (to.name && to.name !== 'partner-home') {
        const siteMap = t(`siteMap.${to.meta.key?.toString()}`);
        document.title = te(`siteMap.${to.meta.key?.toString()}`)
          ? `${siteMap} | ` + document.title
          : document.title;
      }
    });
  }
});
